import type { SupSingleVaultV3 } from "@/types";
import React from "react";

import GridCellsLink from "@/components/Grid/Cell/Link";
import { getProtocolImage, getProtocolName, mapProtocolIcon } from "@/utils";
import { twMerge } from "tailwind-merge";

interface GridCellProtocolProps {
  vault: SupSingleVaultV3;
  className?: string;
}

export default function GridCellProtocol({ vault, className }: GridCellProtocolProps) {
  const protocolIcon = mapProtocolIcon({
    protocol: getProtocolName(vault),
    image_url: getProtocolImage(vault),
  });

  return vault.protocol ? (
    <GridCellsLink
      className={twMerge("flex w-fit rounded-[4px] rounded-tr-none border-0.5 border-primary-200 px-1.5 py-0.5", className)}
      href={`/protocol/${vault.protocol.vanity_url}/`}
    >
      {protocolIcon}
    </GridCellsLink>
  ) : (
    protocolIcon
  );
}
